// What the page says when turning a set on or off fails.

const STATUS_NOT_FOUND = 404;
const GONE = "This set no longer exists. Reload the list.";
const TRY_AGAIN = "Could not change the set. Try again.";

export const toggleFailureMessage = (error) => {
  if (error?.status === STATUS_NOT_FOUND) return GONE;
  if (error?.status && typeof error.detail === "string") return error.detail;
  return TRY_AGAIN;
};
